/**
 * Beta K19 (#1317) — the words around paying after a booking, in one place.
 *
 * Kate, on HTHD grooming: "pay at pickup isn't really a thing". What a client
 * is told depends on how the desk takes payment for THAT service, so the
 * owner can replace the default per service (Settings → Services & prices).
 *
 * Pure and dependency-free: the customer app renders from these, the admin
 * preview renders from these, and the server caps with them. A client reading
 * the outcome page and an owner reading its preview can never see different
 * default wording, because there is only this copy of it.
 *
 * The message is PLAIN TEXT everywhere. It is stored as typed apart from
 * whitespace, and every surface renders it as text (React and the email
 * template both escape it), so markup an owner pastes shows up as characters.
 */

/** Long enough for a sentence or two; short enough to read on a phone. */
export const SERVICE_PAYMENT_MESSAGE_MAX = 300;

/** Today's outcome-page wording. Unchanged for every service with no message. */
export const DEFAULT_PAY_AT_PICKUP_HEADLINE = "Requested — you'll pay at pickup.";
export const DEFAULT_PAY_AT_PICKUP_DETAIL =
  'No card needed now. The front desk will confirm your booking, and you pay when you collect your dog.';

/** The outcome page's headline once an owner's message says how paying works. */
export const OWNER_MESSAGE_HEADLINE = 'Requested — the front desk will confirm your booking.';

/** In a bundle that mixes services, the line for the ones with no message. */
export const DEFAULT_PAYMENT_LINE = 'You pay when you collect your dog.';

/**
 * Line breaks, tabs and other control characters collapse to a single space,
 * so one message reads the same on a phone, in an email and in a list, and a
 * stray paste cannot smuggle anything but words onto a client's screen.
 */
export function normalizeServicePaymentMessage(raw: string): string {
  // eslint-disable-next-line no-control-regex
  return raw.replace(/[\s\u0000-\u001f\u007f]+/g, ' ').trim();
}
